import { createContext, useContext, useEffect, useState } from "react";

const API_URL = "https://nakagawa.nkmr.io/portfolio/api/";

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    fetch(API_URL, { signal: controller.signal })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((d) => setData(d))
      .catch((err) => {
        if (err.name !== "AbortError") setError(err);
      });
    return () => controller.abort();
  }, []);

  if (error) {
    return (
      <div className="data-status data-status--error">
        Failed to load data from {API_URL}
        <br />
        <small>{String(error.message || error)}</small>
      </div>
    );
  }
  if (!data) {
    return <div className="data-status">Loading…</div>;
  }
  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
}

export function useData() {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error("useData must be used within DataProvider");
  return ctx;
}
